import { LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode } from "@app/constants/Common";
import { alertMessage } from "@app/constants/Messages";
import { pipelineOptionsToString, pipelineStringToOptions } from "@pages/dvtjcuv/common/PipelineUtil";
import { validatePipelineInputBeforeSave } from "@pages/dvtjcuv/common/ValidateUtils";
import { DVTJCUVPipelineInputMode } from "@pages/dvtjcuv/edit/DVTJCUVPipelineInputForm";
import { requestSaveDVTJCUVPipeline } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import DVTJCUVPipelineInputFormNew from './DVTJCUVPipelineInputFormNew';

const UpdateDVTJCUVPipelineModal = (props) => {
    const [pipeline, setPipeline] = useState({});
    const [isAddMode, setAddMode] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {pipeLineInfo, isShow, onClose} = props

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    const setPipelineInfoForDisplay = (inputPipeline) => {
        setPipeline(pipelineStringToOptions(inputPipeline))
    }

    useEffect(() => {
        if (pipeLineInfo) {
            setPipelineInfoForDisplay(pipeLineInfo)
            setAddMode(!pipeLineInfo.id)
        } else {
            setPipeline({})
            setAddMode(true)
        }
    }, [pipeLineInfo]);


    const onUpdatePipeLineInfo = () => {
        // Validate
        if (!validatePipelineInputBeforeSave(pipeline)) {
            setPipeline({...pipeline})
            return;
        }

        const body = pipelineOptionsToString(pipeline)
        requestSaveDVTJCUVPipeline(body).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose(true)
            } else {
                alertMessage(res.sts_code)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onChangeInputItem = (values, column) => {
        pipeline[column.key] = values
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        
        // Gọi validate function từ component khác
        // if (!validatePipelineInputBeforeSave(pipeline)) {
        //     setPipeline({...pipeline})
        //     return;
        // }
        
        onUpdatePipeLineInfo();
      };

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   style={{zIndex: 3003}}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {isAddMode ? 'Tạo dòng Pipeline mới' : 'Thông tin pipeline'}
                    </Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <form onSubmit={event => {
                    event.preventDefault();
                    onUpdatePipeLineInfo();
                }}>
                <Modal.Body>
                    <DVTJCUVPipelineInputFormNew mode={pipeline.id ? DVTJCUVPipelineInputMode.Edit : DVTJCUVPipelineInputMode.Add}
                                          onChangeInputItem={onChangeInputItem} pipeLineInfo={pipeline}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='submit'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={isLoading || pipeline.read_only}
                            // onClick={() => {
                            //     onUpdatePipeLineInfo()
                            // }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default UpdateDVTJCUVPipelineModal;
